import { combineReducers } from 'redux';
import proposalReducer from '../../main/apps/proposals/store/proposal';
import proposalsReducer from '../../main/apps/proposals/store/proposals';
import personReducer from '../../main/apps/people/store/person';
import peopleReducer from '../../main/apps/people/store/people';
import paymentsReducer from '../../main/apps/payments/store/payments';
import loansReducer from '../../main/apps/loans/store/loans';
import loanReducer from '../../main/apps/loans/store/loan';
import loanAnalysisReducer from '../../main/apps/loans/store/analysis';

// combinasr los entities aqui

const entities = combineReducers({
	people: peopleReducer,
	person: personReducer,
	proposals: proposalsReducer,
	proposal: proposalReducer,
	payments: paymentsReducer,
	loans: loansReducer,
	loan: loanReducer,
	loanAnalysis: loanAnalysisReducer,
});

export default entities;
